import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Button as AsurionButton, Icon, Text, Size } from "@trailhead/asurion-ui";
import OpenEnrollmentImg from "../assets/open-enrollment-img.png";
import { trackEvent } from "@trailhead/analytics";

const breakpointSm = `(max-width: ${Size.SM - 1}px)`;

const CardContainer = styled.div`
  border: 1px solid #A5AAAF;
  border-radius: 8px;
  gap: 24px;

  display: flex;
  flex-direction: row;
  align-items: flex-start;

  @media (max-width: ${Size.MD - 1}px) {
    flex-direction: column-reverse;
    align-items: center;
  }

  align-self: stretch;
  padding: 24px;

  -webkit-box-sizing: border-box; /* Safari/Chrome, other WebKit */
  -moz-box-sizing: border-box;    /* Firefox, other Gecko */
  box-sizing: border-box;         /* Opera/IE 8+ */
`;

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex: 0 0 271px;

  -webkit-box-sizing: border-box; /* Safari/Chrome, other WebKit */
  -moz-box-sizing: border-box;    /* Firefox, other Gecko */
  box-sizing: border-box;         /* Opera/IE 8+ */
`;

const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  margin-bottom: 16px;

  -webkit-box-sizing: border-box; /* Safari/Chrome, other WebKit */
  -moz-box-sizing: border-box;    /* Firefox, other Gecko */
  box-sizing: border-box;         /* Opera/IE 8+ */
`;

const MainHeader = styled(Text)`
  margin-bottom: 16px;
`

const ListContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  margin-bottom: 16px;

  -webkit-box-sizing: border-box; /* Safari/Chrome, other WebKit */
  -moz-box-sizing: border-box;    /* Firefox, other Gecko */
  box-sizing: border-box;         /* Opera/IE 8+ */
`;

const ImageWrapper = styled.div`
  align-self: center;
  flex-grow: 1;
  display: flex;
  flex-direction: row;
  justify-content: center;

  -webkit-box-sizing: border-box; /* Safari/Chrome, other WebKit */
  -moz-box-sizing: border-box;    /* Firefox, other Gecko */
  box-sizing: border-box;         /* Opera/IE 8+ */
`;

const ImageContainer = styled.img`
`;

const ListItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0px 0px 8px;
  align-self: stretch;

  align-items: flex-start;

  :last-child {
    padding-bottom: 0px;
  }

  -webkit-box-sizing: border-box; /* Safari/Chrome, other WebKit */
  -moz-box-sizing: border-box;    /* Firefox, other Gecko */
  box-sizing: border-box;         /* Opera/IE 8+ */
`;

const Item = styled.div`
  display: inline-block;

  -webkit-box-sizing: border-box; /* Safari/Chrome, other WebKit */
  -moz-box-sizing: border-box;    /* Firefox, other Gecko */
  box-sizing: border-box;         /* Opera/IE 8+ */
`;

const IconWrapper = styled(Icon)`
  margin-right: 8px;
`

type ListItemProps = {
  text: string;
}

const ListItem: React.FC<ListItemProps> = ({text}) => (
    <ListItemContainer>
      <Item>
        <IconWrapper src={"CheckmarkV"} size={"large"} />
        <Text size={2}>{text}</Text>
      </Item>
    </ListItemContainer>
  )

export const OpenEnrollmentCard: React.FC = () => {
  const [isSmallDevice, setIsSmallDevice] = useState(
    window.matchMedia(breakpointSm).matches
  );

  useEffect(() => {
    window.matchMedia(breakpointSm)
      .addEventListener("change", e => setIsSmallDevice(e.matches));
  }, [])

  const onEnrollmentClick = () => {
    const openEnrollmentUrl = "https://www.verizon.com/solutions-and-services/insurance-and-repair/insurance/";
    trackEvent("Open_Enrollment_Button_Click", {
      enrollmentUrl: openEnrollmentUrl
    })
    window.open(openEnrollmentUrl, "_blank");
  }

  return (
    <CardContainer>
      <ContentContainer>
        <HeaderContainer>
          <MainHeader
            size={isSmallDevice ? 4 : 5}
            weight={"feather"}
          >
            It's not too late to protect your phone
          </MainHeader>
          <Text
            size={2}
            >
            You may be eligible for coverage from:
          </Text>
        </HeaderContainer>
        <ListContainer>
          <ListItem text="Loss and theft" />
          <ListItem text="Damage (including liquid)" />
          <ListItem text="Post-warranty defects and more" />
        </ListContainer>
        <AsurionButton
          color={"secondary"}
          variant={"outline"}
          onClick={() => onEnrollmentClick() }
        >
          Explore protection
        </AsurionButton>
      </ContentContainer>
      <ImageWrapper>
        <ImageContainer src={OpenEnrollmentImg} />
      </ImageWrapper>
    </CardContainer>
  )
}